import { updateLayout } from "action/product/updateLayout";
import SezzleWidget from "component/design-system/bnpl-widget/sezzleWidget";
import { RootState } from "interfaces/generics.type";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { isMerchandiseCategory } from "util/product/apparel";
import ProductFilterLayout from "../filter/product-filter-layout/ProductFilterLayout";
import SortFilterButton from "../filter/sort-filter-button/SortFilterButton";
import styles from "./metaInfoBar.module.scss";

function MetaInfoBar(props) {
  const {
    pageType, metaInfoRef, appliedFilters, url, // garageTitle
  } = props;
  const productLayout = useSelector((state: RootState) => state.utils.layout);
  const { urlInformation } = useSelector((store: RootState) => store.utils);
  const dispatch = useDispatch();
  const isMerchandiseCat = isMerchandiseCategory(urlInformation);

  return (
    <div className={styles.product_filter_results} id="meta-info" ref={metaInfoRef}>
      <div className="d-flex justify-content-between align-items-center p-10">

        {/* <div className={styles.garage_title}>
          <ProductFilterVehicleComponent garageTitle={garageTitle} hideVehicleSelector />
        </div> */}
        <div className="hidden-sm hidden-md">
          <SezzleWidget className="show p-l-10" />
        </div>

        <div data-testid="order-filter" className={styles.controls_container}>

          <SortFilterButton appliedFilters={appliedFilters} url={url} />
          <HideIf show={!isMerchandiseCat}>
            <ProductFilterLayout
              {...{ pageType }}
              value={productLayout}
              onChange={(layout: any) => dispatch(updateLayout(layout))}
            />
          </HideIf>
        </div>
      </div>
    </div>
  );
}

export default MetaInfoBar;
